import { put, takeLatest } from "redux-saga/effects";
import { getTotalNotificationApi } from "store/api/NotificationApi";
import { GET_TOTAL_NOTIFICATION_ACTION } from "../../actions/NotificationPageAction/actionTypes";

import * as notificationPageAction from "../../actions/NotificationPageAction";
import * as globalAction from "../../actions/GlobalAction";

function* errorMessage(message) {
	const alert = { isError: true, message: message, isOpenAlert: true };
	yield put(globalAction.setAlertMessage(alert));
}

function* getTotalNotification() {
	const res = yield getTotalNotificationApi();
	try {
		if (res?.code === 0) {
			yield put(
				notificationPageAction.setTotalNotificationAction(
					res?.data?.total
				)
			);
		} else {
			yield errorMessage(res?.message);
		}
	} catch (e) {
		console.log(e);
	}
}

function* getTotalNotificationSaga() {
	yield takeLatest(GET_TOTAL_NOTIFICATION_ACTION, getTotalNotification);
}

export default getTotalNotificationSaga;
